import toRadian from 'helpers/toRadian'

/**
 * Calculates distance based on horizontal field of view, angle of view, and imager count.
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Number} args.horizontalResolution
 * @param {Number} args.angleOfView
 * @return {Number}
 */

export default function calculateDistanceFromHorizontalFieldOfView({ horizontalFieldOfView, angleOfView }) {
  return horizontalFieldOfView / (Math.PI * (angleOfView / 180))
}



// WEBPACK FOOTER //
// ./src/helpers/calculations/calculateDistanceFromHorizontalFieldOfView.js